export default "__VITE_ASSET__C8izNTPo__"